import type { NavinaAppointmentId, NavinaPatientId } from '@navina/api-types';

const APPOINTMENT_PORTRAIT_PREFIX_PATH = '';
type AppointmentPortraitPath = `${typeof APPOINTMENT_PORTRAIT_PREFIX_PATH}/${string}`;

interface GetAppointmentPortraitPathParams {
	readonly navinaAppointmentId: NavinaAppointmentId;
}

export function getLegacyAppointmentPortraitPath({
	navinaAppointmentId,
}: GetAppointmentPortraitPathParams): AppointmentPortraitPath {
	return `${APPOINTMENT_PORTRAIT_PREFIX_PATH}/${navinaAppointmentId}` as const satisfies AppointmentPortraitPath;
}

interface GetPatientPortraitPathParams extends Partial<GetAppointmentPortraitPathParams> {
	readonly navinaPatientId: NavinaPatientId;
}

const PATIENT_PORTRAIT_PREFIX_PATH = '/patient';
type PatientPortraitPath = `${typeof PATIENT_PORTRAIT_PREFIX_PATH}/${string}`;
const PATIENT_PORTRAIT_APPOINTMENT_PREFIX_PATH = '/appointment';
type PatientPortraitWithAppointmentPath =
	`${PatientPortraitPath}${typeof PATIENT_PORTRAIT_APPOINTMENT_PREFIX_PATH}/${string}`;

export function getPatientPortraitPath({
	navinaPatientId,
	navinaAppointmentId,
}: GetPatientPortraitPathParams): PatientPortraitPath | PatientPortraitWithAppointmentPath {
	if (navinaAppointmentId) {
		return `${PATIENT_PORTRAIT_PREFIX_PATH}/${navinaPatientId}${PATIENT_PORTRAIT_APPOINTMENT_PREFIX_PATH}/${navinaAppointmentId}` as const satisfies PatientPortraitWithAppointmentPath;
	}

	return `${PATIENT_PORTRAIT_PREFIX_PATH}/${navinaPatientId}` as const satisfies PatientPortraitPath;
}

export const EMBEDDED_LEGACY_APPOINTMENT_PORTRAIT_PATH_NAME = 'overlay';
export const EMBEDDED_LEGACY_APPOINTMENT_PORTRAIT_PATH_PREFIX = `/${EMBEDDED_LEGACY_APPOINTMENT_PORTRAIT_PATH_NAME}`;
type EmbeddedLegacyAppointmentPortraitPath =
	`${typeof EMBEDDED_LEGACY_APPOINTMENT_PORTRAIT_PATH_PREFIX}${ReturnType<typeof getLegacyAppointmentPortraitPath>}`;
export function getEmbeddedOverlayLegacyAppointmentPortraitPath(
	params: GetAppointmentPortraitPathParams,
): EmbeddedLegacyAppointmentPortraitPath {
	return `${EMBEDDED_LEGACY_APPOINTMENT_PORTRAIT_PATH_PREFIX}${getLegacyAppointmentPortraitPath(params)}`;
}

const EMBEDDED_PATIENT_PORTRAIT_PATH_NAME = 'embedded';
export const EMBEDDED_PATIENT_PORTRAIT_PATH_PREFIX = `/${EMBEDDED_PATIENT_PORTRAIT_PATH_NAME}`;
type EmbeddedPatientPortraitPath =
	`${typeof EMBEDDED_PATIENT_PORTRAIT_PATH_PREFIX}${ReturnType<typeof getPatientPortraitPath>}`;
export function getEmbeddedPatientPortraitPath(params: GetPatientPortraitPathParams): EmbeddedPatientPortraitPath {
	return `${EMBEDDED_PATIENT_PORTRAIT_PATH_PREFIX}${getPatientPortraitPath(params)}`;
}

export type NavinaSummaryPath =
	| EmbeddedPatientPortraitPath
	| PatientPortraitWithAppointmentPath
	| PatientPortraitPath
	| EmbeddedLegacyAppointmentPortraitPath
	| AppointmentPortraitPath;
